'use strict';

angular.module('ClinicApp').config(function($stateProvider, authorizationProvider) {
  $stateProvider.state('opencare-membership', {
    url: '/opencare-membership/',
    data: {
      wrapperClasses: 'gray-2-bg',
    },
    templateUrl: '/views/opencare-membership.html',
    controller: 'OpencareMembershipCtrl',
    reloadOnSearch: false,
    resolve: {
      auth: authorizationProvider.requireAuthorizedUser,
      pageTitle: function($pageTitle) {
        $pageTitle.set('Opencare Membership');
      },
    },
  });
});

angular.module('ClinicApp').controller('OpencareMembershipCtrl', function($scope, CurrentUser, OpencareMembershipPlans, OpencareConstants, OCEligiblePMS, OCChatWidgetUtil) {
  const { ACTIVE } = OpencareConstants.clinicMembership.status;
  const planNames = Object.values(OpencareConstants.clinicMembership.plan);

  const userClinics = CurrentUser.getClinics();
  const activeClinics = userClinics.filter((clinic) => clinic.membership?.status === ACTIVE);

  // Sort clinics by plan tier asc. Ordering determined by order of OpencareConstants.clinicMembership.plan object
  const clinicsSortedByPlan =
    activeClinics.sort((a, b) => planNames.indexOf(a.membership.plan) - planNames.indexOf(b.membership.plan));

  const highestTierClinic = clinicsSortedByPlan.at(-1);
  // If highest tier clinic has no membership, assume they are premium
  $scope.activeMembershipPlan = highestTierClinic?.membership?.plan || OpencareConstants.clinicMembership.plan.STANDARD;

  $scope.OCEligiblePMS = OCEligiblePMS;
  $scope.faqs = OpencareConstants.clinicMembership.faqs;

  $scope.memberships = Object.values(OpencareMembershipPlans);

  // Promotion Related Logic
  const currentDate = moment();
  const offerEndDate = OpencareConstants.ocProPromotionPeriod.END;
  $scope.offerEndDateDisplay = offerEndDate.format('MMMM Do, YYYY');
  $scope.isOfferActive = currentDate.isBefore(offerEndDate);

  // Opens the in-app Zendesk chat widget (loaded site-wide via the ze-snippet script).
  $scope.openMembershipChat = OCChatWidgetUtil.open;
});
